(function () {
  var DURATION = 10 * 60; // 10 minutos - cambia aquí si quieres otro tiempo
  var STORAGE_KEY = 'louvee_cart_reserved_until';

  function tick() {
    var wrapper = document.getElementById('LouveeReserveTimer');
    var el = document.getElementById('LouveeReserveTimerCount');

    if (!wrapper || !el) {
      localStorage.removeItem(STORAGE_KEY);
      return;
    }

    var now = Date.now();
    var stored = localStorage.getItem(STORAGE_KEY);
    var expiry = stored ? parseInt(stored, 10) : 0;

    if (!expiry || expiry <= now) {
      expiry = now + DURATION * 1000;
      localStorage.setItem(STORAGE_KEY, expiry);
    }

    var remaining = Math.max(0, Math.floor((expiry - now) / 1000));
    var minutes = Math.floor(remaining / 60);
    var seconds = remaining % 60;
    el.textContent = minutes + ':' + (seconds < 10 ? '0' : '') + seconds;

    wrapper.classList.toggle('is-urgent', remaining <= 90);

    if (remaining <= 0) {
      localStorage.removeItem(STORAGE_KEY);
      wrapper.style.display = 'none';
    }
  }

  setInterval(tick, 1000);
  tick();
})();